import React from 'react';
import BlogCard from '../BlogCard/BlogCard';

const Blog = () => {
    const BlogData = [
        {
            name: 'Rashed kobir',
            title: 'An eye for an eye and A tooth for a tooth '
        },
        {
            name: 'Dr. Caudi',
            title: 'Two time of Brush in a day Can keep you Healthy'
        },
        {
            name: 'Dr. John Mitchel',
            title: 'The Tooth Cancer is talking a challenge'
        }
    ]
    return (
        <div className='container pt-5 mt-5'>
            <h4 className='text-center head-color fw-bold'>OUR BLOG</h4>
            <h1 className='text-center display-4' style={{fontWeight:'600'}}>From Our Blog News</h1>
            <div className="row mt-5 pt-5">
                {
                    BlogData.map(item => <BlogCard blogItem={item}></BlogCard>)
                }
            </div>
        </div>
    );
};

export default Blog;